import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import { translate } from 'react-i18next';

import { getFaqQuestion } from 'store/faq';

const FaqAnswer = ({ t, faqQuestion }) => (
  <div className="row">
    <div className="columns small-12 large-8">
      <h2>{faqQuestion.question}</h2>

      <ReactMarkdown source={faqQuestion.answer} />

      <Link className="link-nav" to="/help">
        &larr; {t('general.back')}
      </Link>
    </div>

    <div className="columns small-12 large-4">
      <h4>{t('help.customerService.heading')}</h4>

      <p>{t('help.customerService.description')}</p>

      <Link className="button" to="/contact">
        {t('help.customerService.button')}
      </Link>
    </div>
  </div>
);

FaqAnswer.propTypes = {
  t: PropTypes.func.isRequired,
  faqQuestion: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  faqQuestion: getFaqQuestion(state, ownProps.match.params.id)
});

export default connect(mapStateToProps)(translate()(FaqAnswer));



// WEBPACK FOOTER //
// ./src/containers/FaqAnswer/FaqAnswer.js